/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button,} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../app/store"
import LoadingIndicator from "../../app/components/loading-indicator"
import ExpenseFormModal from "./components/expense-form-modal"
import ExpenseFilterComponent from "./components/expense-filter-component"
import { fetchUserExpenseThunk, fetchExpensesByDateThunk, showModalFormExpenseAction, sumTotalExpensesAction } from "./handle-expenses.slice"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import ExpensesListComponent from "./models/expenses-list-component"

export default function HandleExpenses() {
  const dispatch = useAppDispatch()
  const { expenses, loading} = useAppSelector((state: RootState) => state.expenses)
  const {currentUser} = useAppSelector((state: RootState) => state.login)
  const { userId } = useParams()
  
  useEffect(() => {
    if (userId) {
      // If userId is provided, fetch expenses for that specific user for current day
      const currentDate = new Date().toISOString().split('T')[0]
      dispatch(fetchExpensesByDateThunk({
        date: currentDate,
        userId: userId
      }))
    } else {
      // If no userId, fetch all user expenses
      dispatch(fetchUserExpenseThunk())
    }
  }, [userId, dispatch])

  useEffect(() => {
    dispatch(sumTotalExpensesAction())
  }, [expenses])
  return (
    <>
      <LoadingIndicator open={loading} />
      <ExpenseFormModal />
      {currentUser?.level === 0 && <ExpenseFilterComponent selectedUserId={userId} />}
      <Box marginBottom={3}>
        <Button variant="contained" color="success" onClick={() => dispatch(showModalFormExpenseAction(true))} > AGREGAR GASTO</Button>
      </Box>
      <ExpensesListComponent />
    </>
  )
  
}